// pages/home/home.component.class.jsx
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import "./home.styles.scss";
import "../../components/leads-clients/leads-clients.styles.scss";

import NoSpaceData from "../../components/noSpaceData/no-space-data.component";
import AssignedTasks from "../../components/assigned-tasks/assigned-tasks.component";
import PersonalCalendar from "../../components/assigned-tasks/personal-calendar";
import WelcomeHome from "../../components/welcome-home/welcome-home.component";
import ResizableAutoColumns from "../../components/ResizableLayouts/ResizableAutoColumns";
import ResizableAutoRows from "../../components/ResizableLayouts/ResizableAutoRows";

import WidgetRotator from "../../components/WidgetRotator/WidgetRotator";

import HomeChart from "../../components/charts/HomeChart.component";
import Habits from "../../components/habits/habits.component";
import Journal from "../../components/journal/journal.component";

import Feed from "../../components/socials/Feed";
import PostCreate from "../../components/socials/PostCreate";

import AddButton from "../../components/task-add-btn/AddButton";

import HoverDropdown from "../../components/dropdown/dropdown";

import { ReactComponent as HomeGridIcon1 } from "../../assets/icons/antlogyHomeGridIcon1.svg";
import { ReactComponent as HomeGridIcon2 } from "../../assets/icons/antlogyHomeGridIcon2.svg";
import { ReactComponent as HomeGridIcon3 } from "../../assets/icons/antlogyHomeGridIcon3.svg";

import { BsFullscreen, BsFullscreenExit } from "react-icons/bs";

const Home = () => {
  const spaceData = useSelector((state) => state.space.spaceData);
  const currentUser = useSelector((state) => state.user.currentUser);
  const open = useSelector((state) => state.user.currentUser.open);

  const [journalTab, setJournalTab] = useState(true);
  const [habitsTab, setHabitsTab] = useState(true);
  const [analyticsTab, setAnalyticsTab] = useState(false);

  const [activeTab, setActiveTab] = useState("habits");
  const [feedOn, setFeedOn] = useState(false);

  const [firstColumnHidden, setFirstColumnHidden] = useState(false);
  const [secondColumnHidden, setSecondColumnHidden] = useState(false);

  const [journalCollapsed, setJournalCollapsed] = useState(false);
  const [habitsAnalyticsCollapsed, setHabitAnalyticsCollapsed] =
    useState(false);

  const [numOfPrTasks, setNumOfPrTasks] = useState("0");
  const [numOfPrToday, setNumOfPrTasksToday] = useState("0");
  const [numOfPrTasksPastDue, setNumOfPrTasksPastDue] = useState("0");

  const [widths, setWidths] = useState([200, 200]);
  const [calWidths, setCalWidths] = useState([200, 200]);
  const [heights, setHeights] = useState([200, 200, 200]);
  const [midWidth, setMidWidth] = useState(null);
  const [journalFullscreen, setJournalFullscreen] = useState(false);

  const [postCreateOpen, setPostCreateOpen] = useState(false);
  const [feedRefresh, setFeedRefresh] = useState(0);

  const api = useRef(null);
  const isFirstRender = useRef(true);

  const navigate = useNavigate();

  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  const isSupportedBrowser = iOS();

  useEffect(() => {
    if (!isSupportedBrowser) {
      if (Notification.permission === "granted") {
        //if we have given permission before
        console.log(
          "Permission has already granted, may receive notifications",
        );
        // const notify = new Notification(
        //   "Permission granted, may receive notifications"
        // );
      } else {
        Notification.requestPermission().then((response) => {
          if (response === "granted") {
            const notify = new Notification(
              "Permission granted, may receive notifications now. 😊",
            );
          } else {
            console.log("User haven't given permission");
          }
        });
      }
    }
  }, []);

  // function someMethod() {
  //   const timeout = setTimeout(() => {
  //     let calendarApi = miniCalendarRef?.current.getApi();
  //     calendarApi?.updateSize();
  //   }, 500);
  //   return timeout;
  // }

  // at module scope:
  const isSeparator = (el) => el?.getAttribute?.("role") === "separator";
  const draggingRef = { current: false };

  // in a top-level effect once:
  useEffect(() => {
    const down = (e) => {
      if (isSeparator(e.target)) draggingRef.current = true;
    };
    const up = () => {
      draggingRef.current = false;
    };
    window.addEventListener("pointerdown", down);
    window.addEventListener("pointerup", up);
    window.addEventListener("pointercancel", up);
    return () => {
      window.removeEventListener("pointerdown", down);
      window.removeEventListener("pointerup", up);
      window.removeEventListener("pointercancel", up);
    };
  }, []);

  const colsRef = useRef(null);
  const calColsRef = useRef(null);
  const rowsRef = useRef(null);

  const setMiddleTo320 = () => calColsRef.current?.setWidth(0, 320);
  const resetLeft = () => colsRef.current?.reset(0);
  const resetMiddle = () => calColsRef.current?.reset(0);
  const resetLast = () => calColsRef.current?.reset(1);
  const resetAll = () =>
    colsRef.current?.resetAll() && calColsRef.current?.resetAll();
  const setFirstColTo70 = () => colsRef.current?.setWidth(0, 70);
  const setMiddleTo70 = () => calColsRef.current?.setWidth(0, 70);
  const setLastColTo70 = () => calColsRef.current?.setWidth(1, 70);

  useEffect(() => {
    if (isFirstRender.current) {
      // This code runs only on the very first mount
      console.log("useLayoutEffect: First run on component mount!");
      isFirstRender.current = false; // Set to false after the first run
    } else {
      // This code runs on subsequent updates
      console.log("useLayoutEffect: Subsequent run.");
    }
  }, []);

  useLayoutEffect(() => {
    if (isFirstRender.current) return; // don't fight the drag
    // if (draggingRef.current) return; // don't fight the drag
    if (widths[0] < 180) {
      setFirstColTo70();
      // setActiveTab("");
      setFirstColumnHidden(true);
    } else if (widths[0] > 80) {
      // resetLeft();
      setActiveTab("habits");
      setFirstColumnHidden(false);
    }
  }, [widths]);

  useLayoutEffect(() => {
    if (isFirstRender.current) return; // don't fight the drag
    if (draggingRef.current) return; // don't fight the drag
    if (calWidths[0] < 270) {
      setMiddleTo70();
      setSecondColumnHidden(true);
    } else if (secondColumnHidden && calWidths[0] > 90) {
      resetMiddle();
      setSecondColumnHidden(false);
    }
    // if (calWidths[1] < 270) {
    //   setLastColTo70();
    // }
    // if (calWidths[1] >= 90) {
    //   resetLast();
    //   // setSecondColumnHidden(false);
    // }
  }, [calWidths]);

  // Heights: effects Journal and Habits/Analtytics
  useLayoutEffect(() => {
    if (isFirstRender.current) return; // don't fight the drag
    if (draggingRef.current) return; // don't fight the drag
    // effects Journal
    if (heights[0] < 180) {
      setFirstRowTo70();
      setJournalCollapsed(true);
    } else if (heights[0] > 70) {
      // resetAllRows();
      setJournalCollapsed(false);
    }
  }, [heights[0]]);

  useLayoutEffect(() => {
    if (isFirstRender.current) return; // don't fight the drag
    if (draggingRef.current) return; // don't fight the drag
    // // effects Habits
    if (heights[1] < 140) {
      setSecondRowTo70();
      setHabitAnalyticsCollapsed(true);
    } else if (heights[1] > 70) {
      // resetAllRows();
      setHabitAnalyticsCollapsed(false);
    }
  }, [heights[1]]);

  const setFirstRowTo70 = () => rowsRef.current?.setHeight(0, 70);
  const setSecondRowTo70 = () => rowsRef.current?.setHeight(1, 70);
  const resetAllRows = () => rowsRef.current?.resetAll();

  useLayoutEffect(() => {
    if (isFirstRender.current) return; // don't fight the drag
    if (draggingRef.current) return; // don't fight the drag
    if (heights[0] < 170) {
      setFirstRowTo70();
    } else if (heights[0] > 270) {
      // setSecondRowTo70();
    } else {
      resetAllRows();
    }
  }, [heights]);

  useEffect(() => {
    if (activeTab === "habits") {
      setTimeout(() => {
        resetLeft();
      }, 50);
    }
  }, [activeTab]);

  const handleLayout1 = () => {
    setFirstColTo70();
    setMiddleTo320();
  };
  const handleLayout2 = () => {
    setFirstColTo70();
    setMiddleTo70();
    setTimeout(() => {
      setFirstColumnHidden(true);
      setSecondColumnHidden(true);
    }, 100);
  };

  const handleResetFirstColumn = () => {
    if (firstColumnHidden) {
      resetLeft();
    } else return;
  };
  const handleResetMiddleColumn = () => {
    if (secondColumnHidden) {
      resetMiddle();
    } else return;
  };

  const options = [
    {
      value: "g1",
      content: (
        <>
          <HomeGridIcon1 />
        </>
      ),
    },
    {
      value: "g2",
      content: (
        <>
          <HomeGridIcon2 />
        </>
      ),
    },
    {
      value: "g3",
      content: (
        <>
          <HomeGridIcon3 />
        </>
      ),
    },
  ];

  const handleChangeLayout = (v) => {
    if (v === "g1") {
      resetAll();
    } else if (v === "g2") {
      handleLayout1();
    } else if (v === "g3") {
      handleLayout2();
    }
  };

  return (
    <div className="home">
      <div className="home__welcomeHome">
        <WelcomeHome numOfPrTasks={numOfPrTasks} />
<div
  style={{
    marginBottom: 8,
    display: "flex",
    gap: 8,
    position: "absolute",
    right: 12,
    top: 32,
    zIndex: 81,
  }}
>
  <HoverDropdown
    options={options}
    onChange={handleChangeLayout}
  />
</div>
      </div>
      <div className="home__content" style={{ marginLeft: open ? 0 : 10 }}>
        <div className="home__content-container">
          <ResizableAutoColumns
            ref={colsRef}
            minPx={[80, 80]}
            maxPx={[320, null]} // null = no cap
            gutter={20}
            autoUnlockOnOverflow={false} // optional: if fixed column overflows, it returns to auto
            className="homeCols"
            onWidthsChange={({ px, pct }) =>
              // console.log("widths:", { px, pct })
              setWidths([...px])
            }
          >
            <div className="home__firstcolumn">
              <ResizableAutoRows
                ref={rowsRef}
                minPx={[120, 120]} // min heights
                maxPx={[640, null]} // bottom uncapped
                gutter={20} // handle thickness
                autoUnlockOnOverflow={false}
                className="homeCols"
                onHeightsChange={({ px, pct }) =>
                  // console.log("heights:", { px, pct })
                  setHeights([...px])
                }
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    width: "100%",
                    justifyContent:
                      firstColumnHidden || journalCollapsed
                        ? "center"
                        : "space-around",
                  }}
                  className={
                    firstColumnHidden || journalCollapsed
                      ? "widget-closed-container"
                      : "widget-open-container"
                  }
                  onClick={() => handleResetFirstColumn()}
                >
                  <WidgetRotator
                    key={1}
                    rotated={firstColumnHidden}
                    anchor="top-left"
                  >
                    <div
                      className={
                        journalTab ? "journalactive" : "journalinactive"
                      }
                    >
                      <div
                        className="widgetheader"
                        // onClick={() => setJournalTab(!journalTab)}
                        style={{
                          boxShadow:
                            (firstColumnHidden || journalCollapsed) && "none",
                        }}
                      >
                        <h3>Journal</h3>
                        {!firstColumnHidden && !journalCollapsed && (
                          <div
                            className="notes__form-fullscreen-btn"
                            onClick={() =>
                              setJournalFullscreen(!journalFullscreen)
                            }
                          >
                            {journalFullscreen ? (
                              <BsFullscreenExit
                                size="1.2em"
                                data-tooltip-id="turnOffFullScreen-how"
                              />
                            ) : (
                              <BsFullscreen
                                size="1em"
                                data-tooltip-id="turnOnFullScreen-how"
                              />
                            )}
                          </div>
                        )}
                      </div>
                      {/* <p>List of the Days</p> */}
                    </div>
                  </WidgetRotator>
                  <div
                    style={
                      journalFullscreen
                        ? {
                            position: "fixed",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.7)", // Semi-transparent black background
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000, // Ensure it's on top of other content
                          }
                        : {
                            display: "flex",
                            height:
                              firstColumnHidden || journalCollapsed
                                ? 0
                                : "100%",
                            width: "100%",
                            overflow: "hidden"
                          }
                    }
                    onClick={() => {
                      if (journalFullscreen) {
                        setJournalFullscreen(false);
                      }
                    }}
                  >
                    <Journal
                      currentUser={currentUser}
                      display={
                        firstColumnHidden || journalCollapsed ? "none" : "flex"
                      }
                      fullscreen={journalFullscreen}
                      setJournalFullscreen={setJournalFullscreen}
                    />
                  </div>
                </div>
                <div
                  className={
                    firstColumnHidden || habitsAnalyticsCollapsed
                      ? "widget-closed-container"
                      : "widget-open-container"
                  }
                  onClick={() => handleResetFirstColumn()}
                >
                  <div
                    className={habitsTab ? "habitsactive" : "habitsinactive"}
                    style={{
                      justifyContent:
                        (firstColumnHidden || habitsAnalyticsCollapsed) &&
                        "space-around",
                    }}
                  >
                    <WidgetRotator
                      key={1}
                      rotated={firstColumnHidden}
                      anchor="top-left"
                    >
                      <div
                        className="client__header-tabs"
                        style={{
                          justifyContent: habitsAnalyticsCollapsed
                            ? "center"
                            : "flex-start",
                        }}
                      >
                        <div
                          className={
                            activeTab === "habits"
                              ? "widgetheader"
                              : "widgetheader-nonactive"
                          }
                          onClick={() => setActiveTab("habits")}
                          style={{
                            boxShadow:
                              (firstColumnHidden || habitsAnalyticsCollapsed) &&
                              "none",
                          }}
                        >
                          <h3>Habits</h3>
                        </div>
                        <div
                          className={
                            activeTab === "analytics"
                              ? "widgetheader"
                              : "widgetheader-nonactive"
                          }
                          style={{
                            boxShadow:
                              (firstColumnHidden || habitsAnalyticsCollapsed) &&
                              "none",
                          }}
                          onClick={() => setActiveTab("analytics")}
                        >
                          <h3>Analytics</h3>
                        </div>
                      </div>
                    </WidgetRotator>
                    <div
                      style={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                    <Habits
                      currentUser={currentUser}
                      display={
                        activeTab !== "habits" ||
                        firstColumnHidden ||
                        habitsAnalyticsCollapsed
                          ? "none"
                          : "flex"
                      }
                    />
                    <HomeChart
                      spaceData={spaceData}
                      display={
                        activeTab !== "analytics" ||
                        firstColumnHidden ||
                        habitsAnalyticsCollapsed
                          ? "none"
                          : "flex"
                      }
                    />
                    </div>
                    {/* {spaceData.length === 0 && <NoSpaceData />} */}
                  </div>
                </div>
              </ResizableAutoRows>
            </div>
            <ResizableAutoColumns
              ref={calColsRef}
              minPx={[80, 80]}
              maxPx={feedOn ? [360, null] : [520, null]} // null = no cap
              gutter={20}
              autoUnlockOnOverflow={false} // optional: if fixed column overflows, it returns to auto
              className="homeCols-Cal"
              onWidthsChange={({ px, pct }) =>
                // console.log("widths:", { px, pct })
                setCalWidths([...px])
              }
            >
              <div
                className={
                  secondColumnHidden
                    ? "widget-closed-container"
                    : "widget-open-container"
                }
                onClick={() => handleResetMiddleColumn()}
              >
                <WidgetRotator
                  key={1}
                  rotated={secondColumnHidden}
                  anchor="top-right"
                >
                  <div
                    // className={secondColumnHidden ? "journalactive" : "journalinactive"}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      columnGap: 12,
                    }}
                  >
                    <div
                      className={
                        !feedOn ? "widgetheader" : "widgetheader-nonactive"
                      }
                      onClick={() => setFeedOn(false)}
                      style={{
                        minWidth: secondColumnHidden
                          ? "max-content"
                          : "fit-content",
                        boxShadow: secondColumnHidden && "none",
                      }}
                    >
                      <h3>{currentUser.userName}'s List</h3>
                    </div>
                    <div
                      className={
                        feedOn ? "widgetheader" : "widgetheader-nonactive"
                      }
                      onClick={() => setFeedOn(true)}
                      style={{
                        minWidth: secondColumnHidden
                          ? "max-content"
                          : "fit-content",
                        boxShadow: secondColumnHidden && "none",
                      }}
                    >
                      <h3>Social Feed</h3>
                    </div>
                    {/* <p>List of the Days</p> */}
                  </div>
                </WidgetRotator>
                <AssignedTasks
                  setNumOfPrTasks={setNumOfPrTasks}
                  setNumOfPrTasksToday={setNumOfPrTasksToday}
                  setNumOfPrTasksPastDue={setNumOfPrTasksPastDue}
                  display={secondColumnHidden || feedOn ? "none" : "flex"}
                />
                {/* {!secondColumnHidden && feedOn ? <Feed /> : null} */}
                <Feed
                  display={secondColumnHidden || !feedOn ? "none" : "flex"}
                  refreshToken={feedRefresh}
                  onOpenAuthor={(uid) => navigate(`/profile/${uid}`)}
                  onCreate={() => setPostCreateOpen(true)}
                />
              </div>
              <PersonalCalendar />
            </ResizableAutoColumns>
          </ResizableAutoColumns>
        </div>
      </div>
      <AddButton />
      <PostCreate
        modal
        open={postCreateOpen}
        onClose={() => setPostCreateOpen(false)}
        onPublished={() => {
          setPostCreateOpen(false);
          setFeedRefresh((value) => value + 1);
        }}
      />
    </div>
  );
};

export default Home;
